export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.17-0804.41",
  commitId: "d1c920c8e0d0bb83116598635ca55352af07db0b",
  commitTime: "2026-07-17T08:04:41.000Z",
});
